import createFetcher from './createFetcher';

const doLogout = () => {
  createFetcher('/auth/mystellarq/v0/logout').then(() => {
    window.location.replace(`/loginWithVault`);
  });
};

export default doLogout;
